import { type FC, useState } from 'react';
import { graphql, useFragment } from 'react-relay';
import classnames from 'classnames';

import dibsCss from 'dibs-css';
import { Tooltip } from 'dibs-elements/exports/Tooltip';
import InfoCircle from 'dibs-icons/exports/legacy/InfoCircle';
import InfoCircleFilled from 'dibs-icons/exports/legacy/InfoCircleFilled';

import { estimateInfo } from 'dibs-pricing-guidance/exports/pricingGuidanceMessages';
import { trackPricingGuidanceModuleTooltipView } from 'dibs-pricing-guidance/exports/pricingGuidanceTracking';

import { type PricingGuidanceInfo_item$key } from './__generated__/PricingGuidanceInfo_item.graphql';

type Props = {
    item: PricingGuidanceInfo_item$key;
    iconClassName?: string;
    trigger?: 'siderail';
};

export const PricingGuidanceInfo: FC<Props> = ({ item: itemRef, iconClassName, trigger }) => {
    const item = useFragment(
        graphql`
            fragment PricingGuidanceInfo_item on Item {
                ...pricingGuidanceTracking_item
            }
        `,
        itemRef
    );

    const [showTooltip, setShowTooltip] = useState(false);

    const onShowTooltip = (): void => {
        if (!showTooltip) {
            setShowTooltip(true);
            trackPricingGuidanceModuleTooltipView({
                item,
                trigger,
            });
        }
    };

    const Icon = showTooltip ? InfoCircleFilled : InfoCircle;

    return (
        <div
            onMouseEnter={onShowTooltip}
            onMouseLeave={() => setShowTooltip(false)}
            className={classnames(dibsCss.relative, dibsCss.flex, dibsCss.itemsCenter)}
        >
            <div className={classnames(dibsCss.cursorPointer, dibsCss.flex, dibsCss.itemsCenter)}>
                <Icon className={classnames(dibsCss.h14px, dibsCss.w14px, iconClassName)} />
            </div>
            <Tooltip
                isVisible={showTooltip}
                direction={trigger === 'siderail' ? 'top' : 'right'}
                zIndex="low"
            >
                <div className={dibsCss.whitespaceNormal} id="pdp.pdpRespPricingGuidance.tooltip">
                    {estimateInfo}
                </div>
            </Tooltip>
        </div>
    );
};
